import { Model } from 'pinia-orm';
import Company from "./Company";

export default class CompanyTenants extends Model {

    static get entity () {
        return 'company-tenants'
    }

    static fields () {
        return {
            id: this.uid(),
            use_sso_jit: this.attr(false),
            domain: this.attr(''),
            created_at: this.attr(''),
            updated_at: this.attr(''),

            company: this.belongsTo(Company, 'company_id')
        }
    }
}
